export const FLAG_OPENSHIFT_GITOPS = 'OPENSHIFT_GITOPS';
